@if (notifications$ | async; as notifications) {
  <div
    (click)="onNotificationBellClick()"
    (keydown.enter)="onNotificationBellClick()"
    [core-analytics]="{ action: 'Open', category: 'NOTIFICATIONS' }"
    [ngStyle]="{ 'opacity:0.5': notifications.length === 0 }"
    class="dropdown notification"
    tabindex="0"
    #notification>
    <div class="notification-hoverarea" [ngClass]="{ 'is-active': showNotifications }"></div>
    <a
      href="javascript:void(0)"
      id="notificationMenu"
      class="notification-menu-link"
      [core-analytics]="{ action: 'Dropdown', category: 'NOTIFICATIONS' }"
      [ngClass]="{ 'notification-menu-link--dark': !heroImagesEnabled }"
      [attr.aria-label]="notifications.length ? 'Notifications, ' + notifications.length : 'No notifications'">
      @if (notifications.length > 0) {
        <div [innerText]="notifications.length" class="count animated bounceIn"></div>
      }
    </a>
    <div class="notification-messages">
      @if (showNotifications) {
        <span class="notification-arrow"></span>
      }
      @if (showNotifications) {
        <div class="notification-menu">
          @if (!loadingNotifications) {
            <header class="notification__header">
              <div class="notification__count">
                {{ notifications.length }}
                {{ notifications.length === 1 ? 'new notification' : 'new notifications' }}
              </div>
              @if (notifications.length > 0) {
                <div
                  (click)="clearAllNotifications()"
                  (keydown.enter)="clearAllNotifications()"
                  tabindex="0"
                  class="notification__clear"
                  [core-analytics]="{
                    action: 'Clear all',
                    category: 'NOTIFICATIONS',
                  }"
                  data-notifications-clear-all="clearAll">
                  Clear all
                </div>
              }
            </header>
          }
          @if (loadingNotifications) {
            <div class="notification-loading text-center">
              <div class="loadingRotator"></div>
            </div>
          }
          @if (!loadingNotifications) {
            <ul class="notification__items js-notification__items">
              @for (notification of notifications; track trackByFn($index, notification)) {
                <li class="notification__item notification__item--">
                  @if (notification.loading) {
                    <div class="notification__item-loading text-center">
                      <div class="loadingRotator">
                        <img alt="Loading" class="rotating loader" src="/assets/img/loader.svg" />
                      </div>
                    </div>
                  }
                  @if (notification.data.link) {
                    <a
                      (click)="goToNotificationLink($event, notification)"
                      [core-analytics]="{
                        action: 'Open notification',
                        category: 'NOTIFICATIONS',
                      }"
                      [attr.data-notification-title]="notification.subject"
                      class="notification__link"
                      href="{{ notification.data.link }}"
                      target="_blank">
                      <header class="notification-item__header">
                        <div class="notification__timeline">
                          {{ notification.publishDate || notification.dateCreated | humanTime }}
                          ago
                        </div>
                      </header>
                      <p [innerHTML]="notification.subject" class="notification__title"></p>
                      <p [innerHTML]="notification.notification" class="notification__content"></p>
                      <p class="notification__date">
                        {{ (notification.publishDate || notification.dateCreated) * 1000 | date: 'medium' }}
                      </p>
                    </a>
                  }
                  @if (!notification.data.link) {
                    <div [attr.data-notification-title]="notification.subject" class="notification__no-link">
                      <header class="notification-item__header">
                        <div class="notification__timeline">
                          {{ notification.publishDate || notification.dateCreated | humanTime }}
                          ago
                        </div>
                      </header>
                      <p [innerHTML]="notification.subject" class="notification__title"></p>
                      <p [innerHTML]="notification.notification" class="notification__content"></p>
                      <p class="notification__date">
                        {{ (notification.publishDate || notification.dateCreated) * 1000 | date: 'medium' }}
                      </p>
                    </div>
                  }
                  <img
                    (click)="clearNotification(notification)"
                    (keydown.enter)="clearNotification(notification)"
                    tabindex="0"
                    [core-analytics]="{
                      action: 'Clear notification',
                      category: 'NOTIFICATIONS',
                    }"
                    [attr.data-notification-close]="notification.subject"
                    class="notification__close"
                    src="/assets/img/icons/notification-close.svg"
                    alt="" />
                </li>
              }
            </ul>
          }
        </div>
      }
    </div>
  </div>
}
